import { Stack } from "expo-router";

export default function UserDetailLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
